<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#F2994A"/>
    <path d="M16 18.5V20.5C12.9749 21.3874 11.2494 21.4333 8 20.5V18.5C11.1742 19.3923 12.9457 19.323 16 18.5ZM11 8.49V16.5H13V8.49H16L12 4.5L8 8.49H11Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "NivelAlto"
}
</script>

<style scoped>

</style>
